import { AccordionAppearance } from '@atlas/components';
import classnames from 'classnames';
import { Fragment, useCallback } from 'react';

import AccountMenu from 'components/AccountMenu';
import NavigationMenu from 'components/NavigationMenu';
import ResponsibleGamingMenu from 'components/ResponsibleGamingMenu';
import Settings from 'components/Settings';
import SupportMenu from 'components/SupportMenu';
import Switcher from 'components/Switcher';
import {
  AuthStatus,
  SidebarSize,
  useClientProfile,
  useUISettings,
} from 'store';
import { useBasicRoutes } from 'utils/location';

import styles from './LeftSidebar.module.scss';

const LeftSidebar = () => {
  const [uiSettings, { setLeftSidebar }] = useUISettings();
  const [{ status }] = useClientProfile();
  const sidebarExpanded = uiSettings.leftSidebar === SidebarSize.expanded;
  const [basicRouteName, { isAccount, isStatic }] = useBasicRoutes();
  const shouldRenderNavigationMenu = !isAccount && !isStatic;
  const shouldRenderAccountMenu = status === AuthStatus.signedIn && !isStatic;
  const accordionAppearance = sidebarExpanded
    ? AccordionAppearance.wide
    : AccordionAppearance.icon;
  const accordionStateChangeHandler = useCallback(() => {
    setLeftSidebar(SidebarSize.expanded);
  }, [setLeftSidebar]);

  return (
    <div
      className={classnames(styles['left-sidebar'], styles[basicRouteName], {
        [styles['left-sidebar-expanded']]: sidebarExpanded,
        [styles['left-sidebar-collapsed']]: !sidebarExpanded,
      })}
    >
      {!sidebarExpanded && <Switcher />}
      {shouldRenderNavigationMenu && <NavigationMenu />}
      {shouldRenderAccountMenu && (
        <Fragment>
          <AccountMenu
            asAccordion={!isAccount}
            appearance={accordionAppearance}
            onChangeState={accordionStateChangeHandler}
          />
          <ResponsibleGamingMenu />
        </Fragment>
      )}
      <Settings
        appearance={accordionAppearance}
        onChangeState={accordionStateChangeHandler}
      />
      <SupportMenu
        appearance={accordionAppearance}
        onChangeState={accordionStateChangeHandler}
      />
    </div>
  );
};

export default LeftSidebar;
